/// <reference types="./common.d.mts" />
import * as $bright from "../../../../../bright/bright.mjs";
import * as $project from "../../../../../common/data/project.mjs";
import * as $proposal from "../../../../../common/data/proposal.mjs";
import * as $question from "../../../../../common/data/proposal_element/question.mjs";
import * as $status from "../../../../../common/data/status.mjs";
import * as $translate from "../../../../../common/data/translate.mjs";
import * as $language from "../../../../../common/data/translate/language.mjs";
import * as $brands from "../../../../../ds/ds/brands.mjs";
import * as $button from "../../../../../ds/ds/components/button.mjs";
import * as $dropdown from "../../../../../ds/ds/components/dropdown.mjs";
import * as $label from "../../../../../ds/ds/components/label.mjs";
import * as $l from "../../../../../ds/ds/components/layout.mjs";
import * as $pp from "../../../../../ds/ds/components/profile_picture.mjs";
import * as $skeleton from "../../../../../ds/ds/components/skeleton.mjs";
import * as $tab_bar from "../../../../../ds/ds/components/tab_bar.mjs";
import * as $icons from "../../../../../ds/ds/icons.mjs";
import * as $text from "../../../../../ds/ds/typography/text.mjs";
import * as $bool from "../../../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../../gleam_stdlib/gleam/option.mjs";
import * as $level from "../../../../../grille_pain/grille_pain/toast/level.mjs";
import * as $a from "../../../../../lustre/lustre/attribute.mjs";
import * as $el from "../../../../../lustre/lustre/element.mjs";
import * as $h from "../../../../../lustre/lustre/element/html.mjs";
import * as $e from "../../../../../lustre/lustre/event.mjs";
import * as $css from "../../../../../sketch/sketch/css.mjs";
import * as $model from "../../../../data/model.mjs";
import * as $state from "../../../../data/model/state.mjs";
import * as $msg from "../../../../data/msg.mjs";
import * as $route from "../../../../data/route.mjs";
import * as $common from "../../../../frontend/view/common.mjs";
import * as $translation from "../../../../frontend/view/components/translation.mjs";
import * as $s from "../../../../frontend/view/styles/proposals.mjs";
import { Ok, Error, toList, makeError, isEqual } from "../../../../gleam.mjs";

const FILEPATH = "src/frontend/view/projects/show/common.gleam";

function all_tags() {
  return $label.label(toList([$label.neutral(), $label.content("All tags")]));
}

function proposal_tags(proposal) {
  let no_tags = $list.is_empty(proposal.metadata.tags);
  return $bool.lazy_guard(
    no_tags,
    all_tags,
    () => {
      return $l.row(
        toList([$l.gap(8)]),
        toList([]),
        $list.map(
          proposal.metadata.tags,
          (tag) => {
            return $label.label(
              toList([$label.neutral(), $label.content(tag.name)]),
            );
          },
        ),
      );
    },
  );
}

function proposal_style_guidelines(proposal) {
  let $ = proposal.metadata.style_guidelines;
  if ($ instanceof $option.Some) {
    let style_guidelines = $[0];
    return $label.label(
      toList([
        $label.icon($icons.small($icons.file_edit())),
        $label.icon_left(),
        $label.neutral_light(),
        $label.content(style_guidelines.name),
      ]),
    );
  } else {
    return $label.label(
      toList([
        $label.icon($icons.small($icons.file_edit())),
        $label.icon_left(),
        $label.neutral_light(),
        $label.content("No custom style guidelines"),
      ]),
    );
  }
}

function project_and_proposal_metadata(model, project, proposal) {
  let state = $bright.state(model);
  return $bool.lazy_guard(
    !state.proposals.title_opened,
    $el.none,
    () => {
      let _block;
      let _pipe = project.metadata.integrations;
      _block = $dict.get(_pipe, $project.salesforce);
      let salesforce_integration = _block;
      return $l.row(
        toList([$l.justify("space-between")]),
        toList([]),
        toList([
          $s.proposal_metadata_wrapper(
            toList([]),
            toList([
              proposal_tags(proposal),
              proposal_style_guidelines(proposal),
              (() => {
                if (salesforce_integration instanceof Ok) {
                  let salesforce_integration$1 = salesforce_integration[0];
                  return $label.label(
                    toList([
                      $label.icon($icons.medium($brands.salesforce())),
                      $label.content(salesforce_integration$1.case_id),
                    ]),
                  );
                } else {
                  return $el.none();
                }
              })(),
            ]),
          ),
        ]),
      );
    },
  );
}

export function proposal_back() {
  return $l.row(
    toList([]),
    toList([]),
    toList([
      $button.links.text(
        toList([$e.on_click(new $msg.UserClickedBackArrow())]),
        toList([$icons.small($icons.left_arrow()), $h.text("See all proposals")]),
      ),
    ]),
  );
}

function on_export(proposal) {
  if (proposal instanceof Some) {
    let proposal$1 = proposal[0];
    return $e.on_click(
      (() => {
        let export_message = "You can only export proposals in Word or Excel format. Please reach out to the Steerlab team for support.";
        let export_portal_message = "This proposal was created using a portal. Please the use the portal to export it.";
        let $ = proposal$1.metadata;
        if ($ instanceof $proposal.Portal) {
          return new $msg.ApplicationRequestedToDisplayToast(
            new $level.Error(),
            export_portal_message,
          );
        } else if ($ instanceof $proposal.Document) {
          return new $msg.Docx(new $msg.GenerateDocx(proposal$1.id));
        } else if ($ instanceof $proposal.Questionnaire) {
          return new $msg.Xlsx(new $msg.GenerateXlsx(proposal$1.id));
        } else {
          return new $msg.ApplicationRequestedToDisplayToast(
            new $level.Error(),
            export_message,
          );
        }
      })(),
    );
  } else {
    return $a.none();
  }
}

function mode_tab(active, enabled, on_click, icon, title) {
  return $tab_bar.tab(
    active,
    toList([$a.disabled(!enabled), on_click]),
    toList([
      $l.row(
        toList([$l.align("center"), $l.gap(8)]),
        toList([]),
        toList([$s.details_collaborators_icon(icon), $h.text(title)]),
      ),
    ]),
  );
}

function active_tab(proposal, tab, route, enabled) {
  let _block;
  if (tab instanceof $route.Blocks) {
    _block = [$icons.menu(), "Blocks"];
  } else if (tab instanceof $route.Document) {
    _block = [$icons.table_line(), "Document"];
  } else if (tab instanceof $route.Requirements) {
    _block = [$icons.book(), "Requirements"];
  } else {
    _block = [$icons.book(), "Spreadsheet"];
  }
  let $ = _block;
  let icon = $[0];
  let title = $[1];
  let default_route = $route.default_proposal_tab(proposal);
  if (
    !(route instanceof $route.Projects) ||
    !(route[0] instanceof $route.Proposals)
  ) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "frontend/view/projects/show/common",
      234,
      "active_tab",
      "Pattern match failed, no pattern matched the value.",
      {
        value: route,
        start: 6769,
        end: 6844,
        pattern_start: 6780,
        pattern_end: 6836
      }
    )
  }
  let id = route[0].project_id;
  let proposal_ = route[0].proposal;
  let _block$1;
  let _record = proposal_;
  _block$1 = new $route.ShowProposal(
    _record.id,
    _record.comment_id,
    _record.page,
    _record.question_id,
    _record.sheet,
    new Some(tab),
  );
  let proposal$1 = _block$1;
  let route$1 = new $route.Projects(new $route.Proposals(id, proposal$1));
  let on_click = $e.on_click(new $msg.UserReplacedPage(route$1));
  let active = enabled && (isEqual(
    $option.unwrap(proposal_.tab, default_route),
    tab
  ));
  return mode_tab(active, enabled, on_click, icon, title);
}

export function mode_bar(proposal, route, enabled) {
  return $l.row(
    toList([]),
    toList([]),
    toList([
      $tab_bar.tab_bar(
        toList([]),
        (() => {
          if (proposal instanceof $option.Some) {
            let proposal$1 = proposal[0];
            return $list.map(
              $route.proposal_tabs(proposal$1),
              (tab) => { return active_tab(proposal$1, tab, route, enabled); },
            );
          } else {
            return toList([
              mode_tab(false, false, $a.none(), $icons.menu(), "Blocks"),
            ]);
          }
        })(),
      ),
    ]),
  );
}

function proposal_collaborators_choice(model, project) {
  let state = $bright.state(model);
  return $list.filter_map(
    state.organization.users,
    (user) => {
      let is_selectable = $list.any(
        user.roles,
        (u) => { return u.name === "Contributor"; },
      );
      let is_present = $list.contains(project.collaborators, user.id);
      return $bool.guard(
        !is_selectable,
        new Error(undefined),
        () => {
          let _pipe = $dropdown.choice(user.name, user.id);
          let _pipe$1 = $dropdown.with_icon(
            _pipe,
            $pp.from_user(user.picture, user.initials, new $pp.Small()),
          );
          let _pipe$2 = $dropdown.as_selected(_pipe$1, is_present);
          return new Ok(_pipe$2);
        },
      );
    },
  );
}

function assign_collaborators_dropdown(model, project, proposal) {
  let state = $bright.state(model);
  let _block;
  let _pipe = state.user;
  let _pipe$1 = $option.map(
    _pipe,
    (u) => { return $list.contains(project.owners, u.sub); },
  );
  _block = $option.unwrap(_pipe$1, false);
  let is_owner = _block;
  let is_admin = $list.contains(state.permissions, "admin:organization");
  let can_see_it = is_admin || is_owner;
  return $bool.lazy_guard(
    !can_see_it,
    $el.none,
    () => {
      let choices = proposal_collaborators_choice(model, project);
      let on_selected = (_capture) => {
        return new $msg.UserToggledProjectCollaborator(
          proposal.project_id,
          _capture,
        );
      };
      return $dropdown.dropdown(
        on_selected,
        toList([
          $dropdown.panel_right(),
          $dropdown.placeholder("Assign collaborator"),
          $dropdown.icon($icons.add_user()),
          $dropdown.input_class(
            $css.class$(
              toList([
                $css.compose($text.sm($text.regular)),
                $css.padding_("8px 10px"),
              ]),
            ),
          ),
          $dropdown.disabled(
            (($list.is_empty(choices) || !can_see_it) || (!isEqual(
              proposal.status,
              new $status.InProgress()
            ))),
          ),
        ]),
        choices,
      );
    },
  );
}

export function proposal_collaborators(model, project, proposal) {
  let state = $bright.state(model);
  return $l.row(
    toList([$l.gap(10), $l.align("center")]),
    toList([]),
    toList([
      assign_collaborators_dropdown(model, project, proposal),
      $common.stacked_avatars(
        $project.all_collaborators(project),
        state.organization.users,
      ),
    ]),
  );
}

function on_toggle_title() {
  let _pipe = $e.on_click(new $msg.Project(new $msg.UserToggledProjectTitle()));
  let _pipe$1 = $e.prevent_default(_pipe);
  return $e.stop_propagation(_pipe$1);
}

export function get_language(language, proposal) {
  let languages = proposal.metadata.languages;
  let first = $list.first(languages);
  let is_contained = $list.contains(languages, language);
  if (first instanceof Ok) {
    if (!is_contained) {
      let language$1 = first[0];
      return language$1;
    } else {
      return language;
    }
  } else {
    return language;
  }
}

function proposal_language_selector(
  proposal,
  language,
  display_language_selector
) {
  return $bool.lazy_guard(
    !display_language_selector,
    $el.none,
    () => {
      let _pipe = $translation.selector(
        proposal.metadata.languages,
        get_language(language, proposal),
        proposal.metadata.default_language,
        (var0) => { return new $msg.UserSelectedProposalLanguage(var0); },
      );
      return $el.map(_pipe, (var0) => { return new $msg.Proposal(var0); });
    },
  );
}

export function proposal_title(
  model,
  project,
  proposal,
  display_language_selector
) {
  let state = $bright.state(model);
  return $l.row(
    toList([$l.align("center"), $l.gap(8), $l.flex("1")]),
    toList([]),
    toList([
      $s.collapse_title_icon_button(
        state.proposals.title_opened,
        toList([on_toggle_title()]),
        toList([$icons.medium($icons.arrow_up_line())]),
      ),
      $s.show_title(
        toList([]),
        toList([
          $icons.small($icons.folder()),
          $h.div(toList([]), toList([$h.text(project.name)])),
          (() => {
            if (proposal instanceof Some) {
              let proposal$1 = proposal[0];
              return $l.fragment(
                toList([
                  $h.div(toList([]), toList([$h.text("/")])),
                  $icons.small($icons.proposal_file()),
                  $h.div(toList([]), toList([$h.text(proposal$1.name)])),
                ]),
              );
            } else {
              return $skeleton.skeleton(200, 35);
            }
          })(),
        ]),
      ),
      $l.row(
        toList([$l.gap(6)]),
        toList([]),
        toList([
          (() => {
            if (proposal instanceof Some) {
              let proposal$1 = proposal[0];
              return proposal_language_selector(
                proposal$1,
                state.language,
                display_language_selector,
              );
            } else {
              return $skeleton.skeleton(200, 35);
            }
          })(),
          $button.secondary(
            toList([$a.disabled($option.is_none(proposal)), on_export(proposal)]),
            toList([$icons.small($icons.export$()), $el.text("Export")]),
          ),
        ]),
      ),
    ]),
  );
}

export function header(model, project, proposal, display_language_selector) {
  return $s.header(
    toList([]),
    toList([
      proposal_back(),
      proposal_title(
        model,
        project,
        new $option.Some(proposal),
        display_language_selector,
      ),
      project_and_proposal_metadata(model, project, proposal),
    ]),
  );
}

export function yes_no_answer(question) {
  let _pipe = question.answer.yes_no;
  let _pipe$1 = $option.unwrap(_pipe, "");
  return $translate.parse_yes_no(_pipe$1);
}

export function is_question_enabled(model, project, question) {
  let state = $bright.state(model);
  return (question.ai_processing || (!isEqual(
    question.owner,
    $state.current_user_id(state)
  ))) || $project.completed(project);
}
